/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Knp_Terms_Saved_Changes_SuccessInputs */



/**
* | output |
* | --- |
* | "Saved {count} change(s) successfully" |
*
* @param {Knp_Terms_Saved_Changes_SuccessInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_terms_saved_changes_success = /** @type {((inputs: Knp_Terms_Saved_Changes_SuccessInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Terms_Saved_Changes_SuccessInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Enregistrement réussi de ${i?.count} modification(s)`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Änderungen an ${i?.count} erfolgreich gespeichert`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Salvate ${i?.count} modifiche con successo`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Изменения ${i?.count} успешно сохранены.`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Se guardaron ${i?.count} cambios correctamente`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`已成功保存 ${i?.count} 的更改`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`${i?.count} 件の変更が正常に保存されました`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`${i?.count} परिवर्तन सफलतापूर्वक सहेजे गए`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Alterações ${i?.count} salvas com sucesso`)
	return /** @type {LocalizedString} */ (`Saved ${i?.count} change(s) successfully`)
});